import { KText } from '@/ui-library/components';
import { Button, Flex, Icon, Link } from '@chakra-ui/react';
import { CheckDone01 } from '@kula-ai/icons/dual-tone/CheckDone01';
import { Copy03 } from '@kula-ai/icons/dual-tone/Copy03';
import { useState } from 'react';

export const MeetingLinkDetails = ({ videoDetails, location = '' }) => {
  const { uri: interviewUrl, meeting_code, password } = videoDetails || {};
  const [isCopied, setIsCopied] = useState(false);

  return (
    <Flex flexDir="column" gap="5px" flexDirection="column" p="16px">
      <KText size="sm-bold" color="primary-900">
        Join {location?.replace('_', ' ')} meeting
      </KText>
      <Link
        isExternal
        href={interviewUrl}
        _hover={{ textDecoration: 'none' }}
        _focus={{ boxShadow: 'none' }}
      >
        <KText size="sm" color="primary-700">
          {interviewUrl}
        </KText>
      </Link>
      {meeting_code && (
        <Flex gap="6px" alignItems="center">
          <KText size="sm" color="secondary-800">
            ID:
          </KText>
          <KText size="sm" color="secondary-500">
            {meeting_code}
          </KText>
        </Flex>
      )}
      {password && (
        <Flex gap="6px" alignItems="center">
          <KText size="sm" color="secondary-800">
            Password:
          </KText>
          <KText size="sm" color="secondary-500">
            {password}
          </KText>
        </Flex>
      )}
      <Button
        mt="14px"
        variant="secondary"
        onClick={() => {
          navigator.clipboard.writeText(interviewUrl);
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000);
        }}
      >
        <Icon mr="8px" as={isCopied ? CheckDone01 : Copy03} />{' '}
        {isCopied ? 'Copied' : 'Copy invite link'}
      </Button>
    </Flex>
  );
};
